// src/components/fetchApi.ts

type FetchApiInput = string;

function getApiBase(): string {
  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? 'http://localhost:3001' : '';
}

async function parseJsonSafe(res: Response) {
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('application/json')) return null;
  try {
    return await res.json();
  } catch {
    return null;
  }
}

export async function fetchApi(input: FetchApiInput, init: RequestInit = {}): Promise<Response> {
  const base = getApiBase();

  const path = input.startsWith('/') ? input : `/${input}`;
  const url = `${base}${path}`;

  const headers = new Headers(init.headers || {});
  const bodyAny: any = init.body as any;

  const isFormData =
    typeof FormData !== 'undefined' && bodyAny instanceof FormData;

  if (!isFormData && init.body != null && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(url, {
    ...init,
    credentials: 'include',
    headers,
  });

  // Bestehendes Error-Handling (err.message === '401' / '403') bleibt exakt gleich
  if (res.status === 401) throw new Error('401');
  if (res.status === 403) throw new Error('403');

  if (!res.ok) {
    const data = await parseJsonSafe(res);
    const msg = (data as any)?.errors?.join(' | ') || (data as any)?.error || String(res.status);
    throw new Error(msg);
  }

  // WICHTIG: IMMER Response zurückgeben
  return res;
}
